import { render, staticRenderFns } from "./createinformation.vue?vue&type=template&id=2497b6f1&scoped=true"
import script from "./createinformation.vue?vue&type=script&lang=js"
export * from "./createinformation.vue?vue&type=script&lang=js"
import style0 from "./createinformation.vue?vue&type=style&index=0&id=2497b6f1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2497b6f1",
  null
  
)

export default component.exports